// extracted by mini-css-extract-plugin
export default {"btnContainer":"SelectStandardsModal__btnContainer___OuoQn","footer":"SelectStandardsModal__footer___gsRki","header":"SelectStandardsModal__header___VJsIi"};